import { lazy, Suspense, useEffect } from "react";
import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2013white.css";
import "@grapecity/spread-sheets-charts";

import { SpreadWrapperProvider } from "./shared/screen-components/ExcelViewComponent/SpreadWrapperContext";
import { AgGridProvider } from "./shared/screen-components/AgGridComponent/AgGridContext";
import { ThemeProvider } from "./theme";
import { PartnershipProvider } from "./core/context/PartnershipContext";
import { PageLoader } from "./shared/base-components/PageLoader/PageLoader";
import { SessionExpiredModal } from "./shared/base-components/SessionExpiredModal/SessionExpiredModal";
import { startActivityTracking, stopActivityTracking } from "./utils/activityTracker";
import { SESSION_CONSTANT } from "./shared/utils/SessionConstants";

const AppRoute = lazy(() => import("./App.route"));

function App() {
  useEffect(() => {
  }, []);

  useEffect(() => {
    if (localStorage.getItem(SESSION_CONSTANT.TOKEN_KEY) === null) return;

    startActivityTracking();
    return () => stopActivityTracking();
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <PartnershipProvider>
          <AgGridProvider>
            <SpreadWrapperProvider>
              <Suspense fallback={<PageLoader />}>
                <AppRoute />
              </Suspense>
              <SessionExpiredModal />
            </SpreadWrapperProvider>
          </AgGridProvider>
        </PartnershipProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
